/**
 * @generated SignedSource<<a7a4c32c1762b316cc9b66a1561f4e2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedListedContent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_user" | "PdpSharedCondensedSidebarButtons_user" | "PdpSharedPromoCode_user" | "PdpSharedSidebarFavorites_user">;
  readonly " $fragmentType": "PdpRespCondensedListedContent_user";
};
export type PdpRespCondensedListedContent_user$key = {
  readonly " $data"?: PdpRespCondensedListedContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedListedContent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCondensedSidebarButtons_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarFavorites_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c50a2c12be6be677fb4125ad2dac9281";

export default node;
